module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0742-min.e1f55578.jpg";